module.exports = __webpack_public_path__ + "img/hr-level1_mining_hands_mask.98835bef.png";